import api from './api';
import { ApiResponse, unwrapApiResponse } from '@/utils/api-response.util';
import {
  MeasurementType,
  MeasurementUnit,
  LatestMeasurement,
  MeasurementHistoryItem,
  CreateMeasurementPayload,
  UpdateMeasurementPayload,
  Measurement
} from '../types/metrics';

// Загальні методи
export const getMeasurementTypes = async (): Promise<MeasurementType[]> => {
  const response = await api.get<ApiResponse<MeasurementType[]>>('/body-measurements/measurement-types');
  const data = unwrapApiResponse<MeasurementType[]>(response);
  return Array.isArray(data) ? data : [];
};

export const getMeasurementUnits = async (): Promise<MeasurementUnit[]> => {
  const response = await api.get<ApiResponse<MeasurementUnit[]>>('/body-measurements/measurement-units');
  const data = unwrapApiResponse<MeasurementUnit[]>(response);
  return Array.isArray(data) ? data : [];
};

// CRUD для вимірювань
export const createSingleMeasurement = async (payload: CreateMeasurementPayload): Promise<Measurement> => {
  const response = await api.post<ApiResponse<Measurement>>('/body-measurements', payload);
  return unwrapApiResponse<Measurement>(response);
};

export const createMultipleMeasurements = async (payload: { measurements: CreateMeasurementPayload[] }): Promise<Measurement[]> => {
  const response = await api.post<ApiResponse<Measurement[]>>('/body-measurements/multiple', payload);
  const data = unwrapApiResponse<Measurement[]>(response);
  return Array.isArray(data) ? data : [];
};

export const getMeasurementById = async (id: number): Promise<Measurement> => {
  const response = await api.get<ApiResponse<Measurement>>(`/body-measurements/${id}`);
  return unwrapApiResponse<Measurement>(response);
};

export const updateMeasurement = async (id: number, payload: UpdateMeasurementPayload): Promise<Measurement> => {
  const response = await api.put<ApiResponse<Measurement>>(`/body-measurements/${id}`, payload);
  return unwrapApiResponse<Measurement>(response);
};

export const deleteMeasurement = async (id: number): Promise<void> => {
  await api.delete(`/body-measurements/${id}`);
};

// Історія та останні вимірювання
export const getLatestMeasurements = async (): Promise<LatestMeasurement[]> => {
  const response = await api.get<ApiResponse<LatestMeasurement[]>>('/body-measurements/latest');
  const data = unwrapApiResponse<LatestMeasurement[]>(response);
  return Array.isArray(data) ? data : [];
};

interface GetHistoryParams {
  measurementTypeIds?: number[];
  dateFrom?: string; // YYYY-MM-DD
  dateTo?: string; // YYYY-MM-DD
  limit?: number;
}

export const getMeasurementHistory = async (params: GetHistoryParams): Promise<MeasurementHistoryItem[]> => {
  const queryParams = new URLSearchParams();
  if (params.measurementTypeIds) {
    queryParams.append('measurementTypeIds', params.measurementTypeIds.join(','));
  }
  if (params.dateFrom) {
    queryParams.append('dateFrom', params.dateFrom);
  }
  if (params.dateTo) {
    queryParams.append('dateTo', params.dateTo);
  }
  if (params.limit) {
    queryParams.append('limit', params.limit.toString());
  }

  const response = await api.get<ApiResponse<MeasurementHistoryItem[]>>(`/body-measurements/history?${queryParams.toString()}`);
  const data = unwrapApiResponse<MeasurementHistoryItem[]>(response);
  return Array.isArray(data) ? data : [];
};

export const getClientMeasurementHistory = async (clientId: string, params: GetHistoryParams): Promise<MeasurementHistoryItem[]> => {
    const queryParams = new URLSearchParams();
    if (params.measurementTypeIds) {
        queryParams.append('measurementTypeIds', params.measurementTypeIds.join(','));
    }
    if (params.dateFrom) {
        queryParams.append('dateFrom', params.dateFrom);
    }
    if (params.dateTo) {
        queryParams.append('dateTo', params.dateTo);
    }
    if (params.limit) {
        queryParams.append('limit', params.limit.toString());
    }

    const response = await api.get<ApiResponse<{ measurements: MeasurementHistoryItem[] }>>(`/client/${clientId}/body-measurements/history?${queryParams.toString()}`);
    const data = unwrapApiResponse<{ measurements: MeasurementHistoryItem[] }>(response);
    return Array.isArray(data.measurements) ? data.measurements : [];
}
